import { closeAnimatedSheet, mountAnimatedSheet } from "../utils/sheetAnimation";

export interface SheetOptions {
    dismissible?: boolean;
}

export function showSheet(
    title: string,
    content: HTMLElement,
    onClose?: () => void,
    options: SheetOptions = {},
): () => void {
    const backdrop = document.createElement("div");
    backdrop.className = "modal-backdrop";

    const sheet = document.createElement("div");
    sheet.className = "modal-sheet";

    function close() {
        closeAnimatedSheet(backdrop, onClose);
    }

    if (options.dismissible) {
        const header = document.createElement("header");
        header.className = "item-sheet-header";

        if (title) {
            const heading = document.createElement("h2");
            heading.className = "item-sheet-title";
            heading.textContent = title;
            header.appendChild(heading);
        }

        const dismissBtn = document.createElement("button");
        dismissBtn.type = "button";
        dismissBtn.className = "item-sheet-dismiss";
        dismissBtn.setAttribute("aria-label", "Close");
        dismissBtn.textContent = "×";
        dismissBtn.addEventListener("click", close);
        header.appendChild(dismissBtn);

        sheet.appendChild(header);
    } else if (title) {
        const heading = document.createElement("h2");
        heading.textContent = title;
        sheet.appendChild(heading);
    }

    sheet.appendChild(content);

    backdrop.appendChild(sheet);
    mountAnimatedSheet(backdrop);

    backdrop.addEventListener("click", (e) => {
        if (e.target === backdrop) close();
    });

    return close;
}

export function showPicker<T>(
    title: string,
    items: T[],
    renderLabel: (item: T) => string,
    onSelect: (item: T) => void,
    onDismiss?: () => void,
): void {
    const list = document.createElement("div");
    list.className = "picker-list";

    let selected = false;

    for (const item of items) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "picker-item";
        btn.textContent = renderLabel(item);
        btn.addEventListener("click", () => {
            selected = true;
            close();
            onSelect(item);
        });
        list.appendChild(btn);
    }

    const close = showSheet(title, list, () => {
        if (!selected) onDismiss?.();
    });
}
